//# sourceMappingURL=sparkles.mjs.map
/// <reference types="./sparkles.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function sparkles() {
  return $svg.square(
    12,
    "<path d=\"M7 2.21875C7.6731 2.21875 8.21875 1.67309 8.21875 1H8.78125C8.78125 1.67309 9.3269 2.21875 10 2.21875V2.78125C9.3269 2.78125 8.78125 3.32691 8.78125 4H8.21875C8.21875 3.32691 7.6731 2.78125 7 2.78125V2.21875ZM0.5 5.5C2.15685 5.5 3.5 4.15686 3.5 2.5H4.5C4.5 4.15686 5.84315 5.5 7.5 5.5V6.5C5.84315 6.5 4.5 7.84315 4.5 9.5H3.5C3.5 7.84315 2.15685 6.5 0.5 6.5V5.5ZM2.438 6C3.09359 6.3638 3.63621 6.9064 4 7.562C4.36379 6.9064 4.90641 6.3638 5.562 6C4.90641 5.6362 4.36379 5.0936 4 4.438C3.63621 5.0936 3.09359 5.6362 2.438 6ZM8.625 7C8.625 7.89745 7.89745 8.625 7 8.625V9.375C7.89745 9.375 8.625 10.1026 8.625 11H9.375C9.375 10.1026 10.1026 9.375 11 9.375V8.625C10.1026 8.625 9.375 7.89745 9.375 7H8.625Z\" fill=\"currentColor\" />",
  );
}
